import type { Screen } from "../../app/api/ApiClient";
import type { StateStore } from "../../app/state/StateStore";

import { ScreenMapper } from "./ScreenMapper";

type ConfirmCancelSubscriptionScreen =
    Extract<Screen, { type: "confirmCancelSubscription" }>;

export class ConfirmCancelSubscriptionScreenMapper
    implements ScreenMapper<ConfirmCancelSubscriptionScreen> {

    public readonly type =
        "confirmCancelSubscription" as const;

    constructor(
        private readonly store: StateStore
    ) {}

    public apply(
        screen: ConfirmCancelSubscriptionScreen
    ): void {

        const state =
            this.store.getState();

        this.store.replace({

            ...state,

            primaryScreen: {

                type: "confirmCancelSubscription"

            },

            isLoading: false

        });

    }

}